module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-result@2x-e6aa42a3271cec10e02642bf5c7b387e.png";